module.exports = __webpack_public_path__ + "static/media/typewriter-min.4c8b8e31.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/typewriter-min.jpg
// module id = 47
// module chunks = 0